import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Renderer2, PLATFORM_ID, Inject, Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy ,ChangeDetectorRef,  OnChanges, SimpleChanges, ElementRef} from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
@Component({
    selector: 'svg-wrapper',
    templateUrl: './svg.template.html',
    styleUrls: ['./svg.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
  })

export class SVG{
    @Input() url : string;
    @Input() svg : any;
    protected renderer : Renderer2;
    protected coreEffects : CoreEffects;
    protected element;
    private isServer = false;
    private imageSubscription:  Subscription;
    constructor( 
       protected http: HttpClient,
       protected ref : ChangeDetectorRef,
       coreEffects: CoreEffects,
       renderer: Renderer2,
       elementRef: ElementRef,
       @Inject(PLATFORM_ID) platformId: string
     ){
         this.renderer = renderer;
         this.coreEffects = coreEffects;
         this.element = elementRef.nativeElement;
         this.isServer = isPlatformServer(platformId)
    }
    ngOnChanges(changes : SimpleChanges){
        if ( changes.url  && !this.isServer){
            this.load();
        }
    }
    //image/svg+xml
    private load( ){
        if (this.url){
            this.imageSubscription = this.http.get(this.url, {responseType: 'text'}).subscribe(res  =>{
                let parser = new DOMParser();
                this.svg = parser.parseFromString( res, 'text/xml' );
                this.element.appendChild(this.svg.childNodes[1])
                this.ref.detectChanges();
            })
        }
    }

    private ngOnDestroy(  ){
        if (this.imageSubscription){
            this.imageSubscription.unsubscribe();
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-component/svg/svg.component.ts